import { TRANSFER_HISTORY_DATA, TRANSFER_HISTORY_ERROR, TRANSFER_HISTORY_HIDE_ERROR, TRANSFER_HISTORY_PAYIN_START_LOADER, TRANSFER_HISTORY_PAYIN_STOP_LOADER, TRANSFER_HISTORY_PAYOUT_START_LOADER, TRANSFER_HISTORY_PAYOUT_STOP_LOADER, TRANSFER_HISTORY_FILTERS, FILTER_HISTORY_DATA, } from "../interface/TransferHistory";
const initialState = {
    data: {},
    filteredData: {},
    errorData: { error: null, isOpen: false },
    transferHistoryPayInLoader: false,
    transferHistoryPayOutLoader: false,
    filters: [],
};
const transferHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case TRANSFER_HISTORY_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data, filteredData: action.payload.data });
        case TRANSFER_HISTORY_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case TRANSFER_HISTORY_FILTERS:
            return Object.assign(Object.assign({}, state), { filters: JSON.parse(JSON.stringify(action.payload.filters)) });
        case TRANSFER_HISTORY_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case TRANSFER_HISTORY_PAYIN_START_LOADER:
            return Object.assign(Object.assign({}, state), { transferHistoryPayInLoader: true });
        case TRANSFER_HISTORY_PAYOUT_START_LOADER:
            return Object.assign(Object.assign({}, state), { transferHistoryPayOutLoader: true });
        case TRANSFER_HISTORY_PAYIN_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { transferHistoryPayInLoader: false });
        case TRANSFER_HISTORY_PAYOUT_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { transferHistoryPayOutLoader: false });
        case FILTER_HISTORY_DATA:
            return Object.assign(Object.assign({}, state), { filteredData: action.payload.data });
        default:
            return Object.assign({}, state);
    }
};
export default transferHistoryReducer;
